<template>
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
		<rect x="2.5" y="5" width="17" height="12" rx="2" stroke="currentColor" stroke-width="1.6"></rect>
		<path d="M3 6l8 6 8-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
	</svg>
</template>
